document.addEventListener("DOMContentLoaded",function(){

   const sections = document.querySelectorAll('[data-section]');
      [...sections].forEach((el) => {
        el.addEventListener('click', () => {
          hideAll();
          el.classList.add('active-workflow');
          const elSection = document.getElementById(el.dataset.section)
          elSection.style.display= 'block';
          elSection.scrollIntoView({ behavior: 'smooth' });
        });
      });

      function hideAll() {
        document.getElementsByClassName('active-workflow')[0].classList.remove('active-workflow');
        document.getElementById('gitflow').style.display = 'none';
        document.getElementById('github-flow').style.display = 'none';
        document.getElementById('custom-workflow').style.display = 'none';
      }

      const notifyBtns = document.querySelectorAll('.notify-me-button a');
      notifyBtns.forEach(button => {
        button.addEventListener('click', function(event) {
        event.preventDefault();
        scrollToId('notify-me')
      })

      function scrollToId(id) {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
      
    });

});